var exports = {
  "q": "xdde3148b--55269e--sticky",
};

module.exports = exports;
